import { Component } from 'react';
import classnames from 'classnames';
import {
	Pagination,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from '@mui/material';
import { WithStyles, withStyles } from '@mui/styles';
import APCell from './APCell';
import { generate as xslx } from './utils/xlsx';
import { Series, SeriesField } from './../../../core/types/Series';
import { withTranslate } from '../../../core/TenantProvider';
import APSeriesTableStyles from './styles/APSeriesTable.style';

const StyledTableRow = withStyles((theme) => ({
	root: {
		backgroundColor: '#ffffff', // TODO - Get hex colour codes from constant style variables
		'&:nth-of-type(odd)': {
			backgroundColor: '#F5F5F5', // TODO - Get hex colour codes from constant style variables
		},
		'&.isResponsive': {
			display: 'block',
			width: 'auto',
			borderBottom: '1px solid rgba(224, 224, 224, 1)',
			padding: '1.25em',
			position: 'relative',
		}
	},
}))(TableRow);

interface APSeriesTableProps extends WithStyles<typeof APSeriesTableStyles> {
	// TODO - Check if all of these are being used for APTradesSeriesTable
	hideEvent?: boolean,
	pagination?: number,
	summaryHeader?: string,
	summaryHeaderBrackets?: string,
	colSpanCount?: number,
	dateColumnCopy?: string,
	series: Array<Series> | null,
	translate: Function,
	breakPoint?: any,
	ignoredFields?: any
}

class APTradesSeriesTable extends Component<APSeriesTableProps, {}> {
	table: any;

	state = {
		page: 1
	};

	constructor(props: APSeriesTableProps) {
		super(props);

		this.onChangePage = this.onChangePage.bind(this);
		this.onClick = this.onClick.bind(this);
	}

	onChangePage(evt: any, page: any) {
		this.setState({
			page
		});
	}

	onClick(evt: any) {
		const {
			series, translate
		} = this.props;

		xslx(series, 'Account Statement.xlsx', false, translate);
	}

	render() {
		const {
			// TODO - Check if all of these are being used for APTradesSeriesTable
			classes,
			hideEvent,
			pagination,
			series,
			translate,
			summaryHeader,
			summaryHeaderBrackets,
			dateColumnCopy,
			breakPoint,
			ignoredFields
		} = this.props;

		if (series === null || series.length === 0) {
			return null;
		}

		let display = series;
		if (pagination) {
			const page = this.state.page - 1;
			if (page > 0 && series.length < 10) {
				this.setState({ page: 1 }, () => {
					const pageNumber = 0;
					display = series.slice(pageNumber * pagination, (pageNumber * pagination) + pagination);
				});
			} else {
				display = series.slice(page * pagination, (page * pagination) + pagination);
			}
		}

		const match = window.matchMedia(`(max-width: ${breakPoint ? breakPoint : '840'}px)`);
		const responsiveClass = (match.matches) ? 'isResponsive' : '';
		const ignored = (ignoredFields) ? ignoredFields : [];

		return (
			<TableContainer className={classes.tableContainer}>
				<Table stickyHeader>
					<TableHead>
						<TableRow>
							{/*TODO - Check if this being used for APTradesSeriesTable*/}
							{summaryHeader && (
								<TableCell colSpan={5} className={classnames(classes.tableHeadingCell, responsiveClass)}>
									{summaryHeader} {summaryHeaderBrackets &&
										<span className={classes.tableHeadingCellSpan}>
											({summaryHeaderBrackets})
										</span>}
								</TableCell>
							)}
						</TableRow>
						<TableRow className={classnames(classes.tableRowHeader, responsiveClass)}>
							{!hideEvent && (
								<TableCell className={classnames(classes.tableHeadingCell, responsiveClass)}>
									{dateColumnCopy ? dateColumnCopy : translate('series.table.month.label')}
								</TableCell>
							)}
							{display[0].fields.map(column => (
								!ignored.includes(column.fieldName) &&
								<TableCell
									className={classnames(classes.tableHeaderCell, responsiveClass,
										display[0].fields.length <= 3 ?
											classnames(classes.smallTableHeaderCell,
												classes.smallSearchTableHeaderCell) :
											classes.smallSearchTableHeaderCell)}
									key={column.fieldName}>
									{column.fieldLabel}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{display.map(event => (
							<StyledTableRow className={responsiveClass}>
								{!hideEvent && (
									<TableCell
										data-label={dateColumnCopy ?
											dateColumnCopy : translate('series.table.month.label')}
										className={classnames(classes.tableCell, responsiveClass)}>
										{event.event.eventLabel}
										{event.event.eventLabelSmall &&
											<span className={classnames(classes.tableCellSmallSpan, responsiveClass)}>
												({event.event.eventLabelSmall})
											</span>}
									</TableCell>
								)}
								{event.fields.map((column: SeriesField) => (
									!ignored.includes(column.fieldName) &&
									<TableCell
										data-label={column.fieldLabel}
										className={classnames(classes.tableCell, responsiveClass,
											display[0].fields.length <= 3 ? classnames(classes.smallTableCell,
												classes.smallSearchTableCell) :
												classes.smallSearchTableCell)}
										key={`${event.event.eventLabel}-${column.fieldName}`}>
										<APCell field={column} />
									</TableCell>
								))}
							</StyledTableRow>
						))}
					</TableBody>
				</Table>
				{(pagination && pagination !== 0) ? (
					<div className={classnames(classes.pagination, classes.tradePagination)}>
						<Pagination
							count={Math.ceil(series.length / pagination)}
							page={this.state.page}
							onChange={this.onChangePage}
						/>
					</div>
				) : ''}
			</TableContainer>
		);
	}
}

export default withTranslate(
	withStyles(APSeriesTableStyles)(APTradesSeriesTable)
);
